import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import moment from 'moment-timezone'
import cn from 'classnames'
import { get, find } from 'lodash'

import MonthEventContainer from '../MonthEventContainer'

import VisitOpening from '.'
import requiredPropTypes from './requiredPropTypes'

const renderTime = (startTime) => {
  const timeFormat = startTime.minutes() === 0 ? 'ha' : 'h:mma'
  return startTime.format(`${timeFormat} z`)
}

export const MonthView = (props) => {
  const { event, userId, scid } = props
  const startTime = moment.tz(props.event.StartTime, moment.tz.guess())
  const participant = find(get(event, 'Participants', []), { Scid: scid })
  const myRep = find(get(participant, 'Representatives', []), { UserId: userId })
  const isPending = get(myRep, 'SystemState') === 'pending_state'
  return (
    <VisitOpening
      {...props}
      className={cn('month', {
        'pending-event-summary': isPending,
      })}
      summary={
        <MonthEventContainer isVirtual={props.event.Virtual}>
          {!event.AllDay && renderTime(startTime)} {event.HighSchoolName}
        </MonthEventContainer>
      }
    />
  )
}
MonthView.propTypes = {
  ...requiredPropTypes,
  scid: PropTypes.number.isRequired,
  userId: PropTypes.string.isRequired,
}

export default connect((store) => ({
  userId: store.user.record.Id,
  scid: store.user.record.Scid,
}))(MonthView)
